<!-- @format -->

<template>
	<el-row :gutter="6">
		<el-col :span="24">
			<el-button size="small" class="add-btn" @click="onAdd">新增</el-button>
		</el-col>
		<el-col :span="1" />
		<el-col :span="10">
			<label class="label">关联对象</label>
		</el-col>
		<el-col :span="10">
			<label class="label">关联数据</label>
		</el-col>

		<el-row v-for="(item, idx) in value" :key="idx" :gutter="6">
			<el-col :span="1" />
			<el-col :span="10">
				<el-select v-model="item.code" size="small" placeholder="请选择关联对象">
					<el-option v-for="itm in fieldList" :key="itm.value" :label="itm.label" :value="itm.value" />
				</el-select>
			</el-col>
			<el-col :span="10">
				<el-select v-model="item.link" size="small" placeholder="请选择关联数据">
					<el-option v-for="itm in linkList" :key="itm.value" :label="itm.label" :value="itm.value" />
				</el-select>
			</el-col>
			<el-col :span="3">
				<el-icon v-if="value.length > 1 && idx !== 0" class="form-item-content-icon" @click.stop.prevent="onDel(idx)">
					<Delete />
				</el-icon>
			</el-col>
		</el-row>
	</el-row>
</template>

<script setup lang="ts">
	import { useDragStoreWithOut } from '../../store';
	import { getLinkList } from '../../config/state';
	import { flat } from '../../utils/util';
	import type { FieldsType, LinkConfigType } from '../../types';

	interface Props {
		modelValue: LinkConfigType[];
	}

	const props = withDefaults(defineProps<Props>(), {});

	const emit = defineEmits(['update:modelValue']);

	const name = inject<string>('name');

	const dragStore = useDragStoreWithOut(name);

	const value = computed({
		get() {
			return props.modelValue || [];
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const fieldList = computed(() => {
		const flatWidgetDatas: FieldsType[] = flat(dragStore.widgetDatas);
		return flatWidgetDatas
			.filter((itm) => itm.category === 'field')
			.map((it) => ({ label: it.pcProps.label, value: it.code || '' }));
	});

	const linkList = computed(() => getLinkList(dragStore.selectField.type));

	const onAdd = () => {
		value.value.push({ code: '', link: '' });
	};

	const onDel = (idx: number) => {
		value.value.splice(idx, 1);
	};

	onMounted(() => {
		if (!value.value.length) {
			value.value = [{ code: dragStore.selectField.code, link: linkList.value[0].value }];
		}
	});
</script>

<style scoped>
	.form-item-content-icon {
		cursor: pointer;
	}
</style>
